import exposedServiceTypes from '../../lib/helpers/exposedServiceTypes';

const getServices = services => exposedServiceTypes.map(key => services[key]).flat();

export default getServices;
